<div  
  id="container" 
  class="engine"
  [class.engine--transparent]="isTransparentBackground"
  [ngStyle]="getContainerStyles()"
  #engine >
  <canvas id="theCanvas" class="engine__canvas" #engineCanvas></canvas>
  <canvas id="annotationCanvas" class="engine__annotations" #engineAnnotations></canvas>  
  <app-labels></app-labels>
  
  <app-progress
    class="engine__progress"
    [ngClass]="{'engine__progress--hide': !loading}"
    [value]="assetProgress"
    [total]="assetTotal"></app-progress>
</div>